import React from 'react';

const Splitter = ({label, extraClass, ...props}) => {
    return (
        <div className={`splitterContainer d-flex align-items-center ${extraClass}`}>
            {label && <span className="label mr-2">{label}</span>}
            <hr className="splitter flex-grow-1" />
        </div>
    )
};

export default Splitter;


// WEBPACK FOOTER //
// ./src/customModules/Common/components/Splitter.js